import { SVGProps } from 'react'
import { v4 as uuid } from 'uuid'

export function CheckmarkFilledIcon(props: SVGProps<SVGSVGElement>) {
  const id = uuid()
  return (
    <svg viewBox="2 2 20 20" fill="white" {...props}>
      <path
        d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
        fill="currentColor"
        fillOpacity="0.01"
      />
      <mask id={id} maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20">
        <path
          d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM10 17L5 12L6.41 10.59L10 14.17L17.59 6.58L19 8L10 17Z"
          fill="white"
        />
      </mask>
      <g mask={`url(#${id})`}>
        <rect width="24.24" height="24.24" fill="currentColor" />
      </g>
    </svg>
  )
}
